import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseModalManagement } from 'app/components/common/BaseModalManagement'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseSelect, Option } from 'app/components/common/selects/BaseSelect'
import { Fragment } from 'react'
import { useModalHook } from './hook'
import * as S from './styles'
import { IPropsUpdateUnit, initValues } from './type'
import { isEqual } from 'lodash'
import { ClinicTypeEnumList, DefineClinicType } from '../../type'

enum StatusUnitOptionsEnum {
  active = 'active',
  // error = 'error',
  inactive = 'inactive',
}

export const Update = (props: IPropsUpdateUnit) => {
  const {
    form,
    visible,
    t,
    isLoading,
    showModal,
    handleSubmit,
    handleCancel,
    rules,
    unitGroups,
    unitTypes,
    jobTitles,
    isHaveParent,
    units,
    onChangeParentCodeSelected,
    parentCodeSelected,
    type,
    onChangeClinicType,
  } = useModalHook(props)

  return (
    <BaseModalManagement
      isLoading={isLoading}
      typeButtonOpen="update"
      titleKeyI18n={R.strings.update}
      content={
        <BaseForm
          layout="vertical"
          onFinish={handleSubmit}
          requiredMark="optional"
          initialValues={initValues}
          form={form}
        >
          <S.FormItem name="_id" label={t(R.strings.unit_content__id)} required>
            <S.FormInput
              disabled
              placeholder={t(R.strings.enter_field, {
                field: t(R.strings.unit_content__id),
              })}
            />
          </S.FormItem>

          {isHaveParent ? (
            <BaseRow gutter={[16, 8]} align={'top'}>
              <BaseCol xl={12}>
                <S.FormItem
                  name={'unitParentName'}
                  label={t(R.strings.unit_content_unit_parent)}
                  required
                >
                  <S.FormInput
                    disabled
                    placeholder={t(R.strings.enter_field, {
                      field: t(R.strings.unit_content_unit_parent),
                    })}
                    value={parentCodeSelected}
                  />
                </S.FormItem>
              </BaseCol>
              <BaseCol xl={12}>
                <BaseRow
                  wrap={false}
                  gutter={[16, 8]}
                  align={'top'}
                  justify={'space-between'}
                >
                  <BaseCol xl={12}>
                    <S.FormItem label={t(R.strings.unit_content_id)} required>
                      <S.FormInput
                        disabled
                        placeholder={t(R.strings.enter_field, {
                          field: t(R.strings.unit_content_id),
                        })}
                        value={parentCodeSelected}
                      />
                    </S.FormItem>
                  </BaseCol>

                  <BaseCol xl={12}>
                    <S.FormItem name="code" rules={rules.code}>
                      <S.FormInput
                        placeholder={t(R.strings.enter_field, {
                          field: t(R.strings.unit_content_id),
                        })}
                      />
                    </S.FormItem>
                  </BaseCol>
                </BaseRow>
              </BaseCol>
            </BaseRow>
          ) : (
            <Fragment>
              <S.FormItem
                label={t(R.strings.unit_content_unit_parent)}
                name={'parentid'}
              >
                <BaseSelect
                  options={units?.map(itm => ({
                    label: itm?.name,
                    value: itm?._id,
                  }))}
                  placeholder={t(R.strings.please_select_unit_parent)}
                  onChange={value =>
                    onChangeParentCodeSelected(value as string)
                  }
                  allowClear
                  showSearch
                />
              </S.FormItem>
              <S.FormItem
                name="code"
                label={t(R.strings.unit_content_id)}
                rules={rules.code}
                required
              >
                <S.FormInput
                  placeholder={t(R.strings.enter_field, {
                    field: t(R.strings.unit_content_id),
                  })}
                />
              </S.FormItem>
            </Fragment>
          )}

          <BaseRow gutter={[16, 8]} align={'top'}>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_content_unitTypeId)}
                name="unitTypeId"
                rules={rules.unitTypeId}
                required
              >
                <S.SelectBaseStyled
                  placeholder={t(
                    R.strings.unit_content_please_select_unitTypeId,
                  )}
                  showSearch
                  options={unitTypes?.map(unitType => ({
                    value: unitType?._id,
                    label: unitType?.name,
                  }))}
                  onChange={id => onChangeClinicType(id as string)}
                />
              </S.FormItem>
            </BaseCol>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_content_unit_department)}
                name="unitGroupId"
                rules={rules.unitGroupId}
                required
              >
                <S.SelectBaseStyled
                  placeholder={t(
                    R.strings.unit_content_please_select_unit_department,
                  )}
                  showSearch
                  options={unitGroups?.map(unitGroup => ({
                    value: unitGroup?._id,
                    label: unitGroup?.name,
                  }))}
                />
              </S.FormItem>
            </BaseCol>
          </BaseRow>
          {isEqual(type?.toLowerCase(), 'Clinic'.toLowerCase()) ? (
            <S.FormItem
              label={t(R.strings.clinic_type)}
              name="clinicType"
              rules={rules.clinicType}
              required
            >
              <S.SelectBaseStyled
                placeholder={t(R.strings.select_clinic_type)}
                options={ClinicTypeEnumList?.map(type => ({
                  value: type,
                  label: t(DefineClinicType[type].keyI18n),
                }))}
                showSearch
              />
            </S.FormItem>
          ) : null}
          <BaseRow gutter={[16, 8]} align={'middle'}>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_field_job_title_management)}
                name="jobTitleIdManagement"
              >
                <S.SelectBaseStyled
                  placeholder={t(
                    R.strings
                      .unit_content_please_select_unit_job_title_management,
                  )}
                  showSearch
                  options={jobTitles?.map(jobTitle => ({
                    value: jobTitle?._id,
                    label: jobTitle?.name,
                  }))}
                  allowClear
                />
              </S.FormItem>
            </BaseCol>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_field_job_title_vice)}
                name="jobTitleIdVice"
              >
                <S.SelectBaseStyled
                  placeholder={t(
                    R.strings.unit_content_please_select_unit_job_title_vice,
                  )}
                  showSearch
                  allowClear
                  options={jobTitles?.map(jobTitle => ({
                    value: jobTitle?._id,
                    label: jobTitle?.name,
                  }))}
                />
              </S.FormItem>
            </BaseCol>
          </BaseRow>
          <S.FormItem
            name="name"
            label={t(R.strings.unit_content_name_create)}
            rules={rules.name}
            required
          >
            <S.FormInput
              placeholder={t(R.strings.enter_field, {
                field: t(R.strings.unit_content_name_create),
              })}
            />
          </S.FormItem>

          <S.FormItem
            name="description"
            label={t(R.strings.unit_content_description)}
          >
            <S.FormInput.TextArea
              showCount
              maxLength={300}
              placeholder={t(R.strings.enter_field, {
                field: t(R.strings.unit_content_description),
              })}
            />
          </S.FormItem>

          <S.FormItem
            label={t(R.strings.status)}
            name="status"
            rules={rules.status}
            required
          >
            <S.SelectBaseStyled
              placeholder={t(R.strings.please_select_status)}
              defaultValue={StatusUnitOptionsEnum.active}
            >
              {Object.values(StatusUnitOptionsEnum)?.map((item, index) => {
                return (
                  <Option value={item} key={index}>
                    {t(item)}
                  </Option>
                )
              })}
            </S.SelectBaseStyled>
          </S.FormItem>
        </BaseForm>
      }
      showModal={showModal}
      handleCancel={handleCancel}
      textOpenModalI18n={R.strings.update}
      confirmKeyI18n={R.strings.update}
      handleSubmit={form.submit}
      visible={visible}
    />
  )
}
